<template>
  <el-container direction="vertical" style="margin: 5vh 5vw">
    <process-log :isVisible.sync="showModal" :recordSelected="recordSelected" />
    <PdfModal :isVisible.sync="dateModal" @makePdf="makePdf" />
    <div class="header">
      <h2>All Tasks</h2>
    </div>
    <div style="display: flex; align-items: center">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="height: 55px; line-height: 55px"
      >
        <el-breadcrumb-item :to="{ path: `/servers/${instanceId}/tasks` }"
          >Tasks</el-breadcrumb-item
        >
        <el-breadcrumb-item>History</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="flex-grow: 1"></div>
      <!-- <el-button
        class="button"
        @click="dateModal = true"
        style="
          text-align: center;
          padding: 18px;
          width: 125px;
          height: 40px;
          float: right;
          line-height: 15%;
        "
      >
        Download PDF</el-button
      > -->
    </div>
    <!-- <el-input v-model="filter" placeholder="Type to search" style="width: 30%; margin-bottom: 12px" /> -->
    <slider>
      <template #table>
        <taskTable
          v-if="itemsToShow.length > 0"
          ref="taskTable"
          @selectHistory="selectHistory"
          :itemsToShow="itemsToShow"
          :tableFormat="tableFormat"
        />
      </template>
      <template #details>
        <taskDetails
          ref="taskDetails"
          @tabClicked="tabClicked"
          @setShowModal="setShowModal"
          :showModal="showModal"
          :itemsToShow="itemsToShow"
          :activeTab="activeTab"
          :activeRecord="activeRecord"
          :historyDetails="historyDetails"
          :logData="logData"
        />
      </template>
    </slider>
  </el-container>
</template>

<script>
// could be added
//TODO:see if you can export the right hand side
import ProcessLog from "../components/modals/ProcessLog";
import TaskService from "../services/TaskService";
import taskDetails from "../components/TaskDetails.vue";
import PdfModal from "../components/modals/DatePdf";
import taskTable from "../components/TaskTable.vue";
import slider from "../components/Draggable.vue";
import moment from "moment-timezone";
import { mapState } from "vuex";
import Helper from "../utilities/Helper";
import store from "../store/store";

export default {
  data() {
    return {
      showModal: false,
      dateModal: false,
      items: [],
      itemsToShow: [],
      filter: null,
      activeTab: "Details",
      activeRecord: {},
      historyDetails: {},
      logData: [],
      listByName: [],
      listTaskName: [],
      resultTasks: [],
      pendingHistories: [],
      pendingIds: [],
      recordSelected: null,
      tableFormat: [],
      timezone:
        process.env.VUE_APP_SERVER_TIMEZONE ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      timer: "",
    };
  },
  components: { ProcessLog, taskDetails, taskTable, slider, PdfModal },
  computed: {
    ...mapState([
      "currentTaskName",
      "instanceId",
      "taskId",
      "isUserLoggedIn",
      "environmentId",
    ]),
  },
  methods: {
    handleError: Helper.handleError,
    async combineSingleCubeDims() {
      const sourceViewDims = this.historyDetails.source.taskHistoryDims.slice();
      const targetViewDims = this.historyDetails.target.taskHistoryDims.slice();

      const response = await TaskService.getCubeDims({
        cubeName: this.historyDetails.target.taskHistoryCube.name,
        instanceId: this.instanceId,
      });
      const targetCubeDims = response.data.dims.value;

      sourceViewDims.forEach((sourceDim) => {
        const foundInTargetViewDims = targetViewDims.find(
          (dim) => dim.name === sourceDim.name
        );
        if (!foundInTargetViewDims) {
          const foundInTargetCubeDims = targetCubeDims.find(
            (dim) => dim.Name === sourceDim.name
          );
          if (foundInTargetCubeDims) {
            const index = sourceViewDims.indexOf(sourceDim);
            this.historyDetails.target.taskHistoryDims[index] = sourceDim;
          }
        } else {
          const index = sourceViewDims.findIndex(
            (dim) => dim.name === foundInTargetViewDims.name
          );
          this.historyDetails.target.taskHistoryDims[index] =
            foundInTargetViewDims;
        }
      });
    },
    combineMultipleCubesDims() {
      const sourceViewDims = this.historyDetails.source.slice();
      const targetViewDims = this.historyDetails.target.slice();

      sourceViewDims.forEach((sourceDim) => {
        const found = targetViewDims.find((dim) => dim.name === sourceDim.name);
        if (!found) {
          const index = sourceViewDims.indexOf(sourceDim);
          this.historyDetails.target[index] = sourceDim;
        } else {
          const index = sourceViewDims.findIndex(
            (dim) => dim.name === found.name
          );
          this.historyDetails.target[index] = found;
        }
      });
    },
    async selectHistory(row) {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        this.activeRecord = row;

        const detailsRepsonse = await TaskService.getHistoryDetails({
          taskHistoryId: this.activeRecord.id,
        });
        const taskHistoryDetails = detailsRepsonse.data.taskHistoryDetails;
        if (this.activeRecord.source === "Single Cube") {
          this.historyDetails = {
            source:
              taskHistoryDetails[0].taskHistoryCube.type === "source"
                ? taskHistoryDetails[0]
                : taskHistoryDetails[1],
            target:
              taskHistoryDetails[0].taskHistoryCube.type === "target"
                ? taskHistoryDetails[0]
                : taskHistoryDetails[1],
          };

          if (this.activeRecord.target !== "File")
            await this.combineSingleCubeDims();
        } else if (this.activeRecord.source === "Multiple Cubes") {
          this.historyDetails = {
            source: [],
            target: [],
          };

          for (let i = 0; i < taskHistoryDetails.length; i++) {
            if (taskHistoryDetails[i].type === "source") {
              this.historyDetails.source.push(taskHistoryDetails[i]);
            } else if (taskHistoryDetails[i].type === "target") {
              this.historyDetails.target.push(taskHistoryDetails[i]);
            }
          }

          this.combineMultipleCubesDims();
        } else if (this.activeRecord.source === "Value") {
          this.historyDetails = {
            target: taskHistoryDetails[0],
          };
        }

        this.logData = [];
        const logResponse = await TaskService.getLog({
          taskHistoryId: this.activeRecord.id,
        });
        for (const record of logResponse.data.log) {
          record.createdAt = moment(record.createdAt)
            .tz(this.timezone)
            .format("h:mm:ss A on LL");
          this.logData.push(record);
        }
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    async tabClicked(tab) {
      if (tab.name === "Log") {
        await this.updateLog();
      }
    },
    async updateLog() {
      this.logData = [];
      const logResponse = await TaskService.getLog({
        taskHistoryId: this.activeRecord.id,
      });
      for (const record of logResponse.data.log) {
        record.createdAt = moment(record.createdAt)
          .tz(this.timezone)
          .format("h:mm:ss A on LL");
        this.logData.push(record);
      }
    },
    async renderLog() {
      let container = this.$refs.logsTab;
      let scrollBottom = false;
      const currScroll = container.$el.scrollTop;

      if (
        currScroll + container.$el.clientHeight >=
        container.$el.scrollHeight
      ) {
        scrollBottom = true;
      }
      await this.updateLog();

      scrollBottom === true
        ? (container.$el.scrollTop = container.$el.scrollHeight)
        : (container.$el.scrollTop = currScroll);
    },
    async setShowModal() {
      this.showModal = true;
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    async getHistory() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        const response = await TaskService.getAllHistory({
          instanceId: this.instanceId,
        });
        //uses sets to avoid repeated values for the filter options
        let setByName = new Set();
        let setResultTasks = new Set();
        let setTaskName = new Set();
        for (let history of response.data.totalHistory) {
          //gets all the data details for a task.
          const taskHistory = history.taskHistory;

          taskHistory.duration =
            moment(taskHistory.updatedAt).diff(
              moment(taskHistory.createdAt),
              "seconds"
            ) + " seconds";

          taskHistory.createdAt = moment(taskHistory.createdAt)
            .tz(this.timezone)
            .format("h:mm:ss A on LL");

          taskHistory.runBy = history.runBy;

          taskHistory.jobName = history.job;

          taskHistory.taskName = history.taskName;

          setByName.add(taskHistory.runBy);
          setResultTasks.add(taskHistory.result);
          setTaskName.add(taskHistory.taskName);

          if (taskHistory.result === "Pending") {
            this.pendingHistories.push(taskHistory);
            this.pendingIds.push(taskHistory.id);
          }
          this.itemsToShow.push(taskHistory);
        }

        this.itemsToShow.sort(this.sortDate).reverse();
        //converts sets to arrays
        this.listByName = Array.from(setByName);
        this.resultTasks = Array.from(setResultTasks);
        this.listTaskName = Array.from(setTaskName);
        //sorts array for the filter options
        this.listByName.sort();
        this.resultTasks.sort();
        this.listTaskName.sort();
        //put the filter options into objs that would be accepted to it
        this.listByName = this.listByName.map((name) => {
          return { value: name, text: name };
        });
        this.resultTasks = this.resultTasks.map((name) => {
          return { value: name, text: name };
        });
        this.listTaskName = this.listTaskName.map((name) => {
          return { value: name, text: name };
        });

        if (this.itemsToShow.length > 0) {
          this.activeRecord = this.itemsToShow[0];
          this.$emit("setFirst");
        }
        //table format is for how the table will look like and shows if it is filter
        //and sorted and which value it is
        this.tableFormat = [
          {
            prop: "taskName",
            label: "Name",
            filterOption: this.listTaskName,
            filterMethod: this.filterTaskName,
            filterPlacement: "bottom-end",
          },
          {
            prop: "result",
            label: "Result",
            filterOption: this.resultTasks,
            filterMethod: this.filterTaskResult,
            filterPlacement: "bottom-end",
          },
          {
            prop: "createdAt",
            label: "Started At",
            sortMethod: this.sortDate,
          },
          {
            prop: "runBy",
            label: "Run By",
            filterOption: this.listByName,
            filterMethod: this.filterRunBy,
            filterPlacement: "bottom-end",
          },
        ];
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    async refreshTask() {
      try {
        if (this.pendingIds.length === 0) {
          this.cancelAutoUpdate();
          return;
        }

        if (
          this.pendingIds.indexOf(this.activeRecord.id) != -1 &&
          this.activeTab === "Log"
        ) {
          await this.renderLog();
        }

        const result = await TaskService.getHistoryResults();
        const finishedHistories = result.data.taskHistories;
        const finishedTotal = finishedHistories.length;
        let historyIndex;
        let resultTaskFilter = new Set();

        for (let i = 0; i < finishedTotal; i++) {
          historyIndex = this.pendingIds.indexOf(finishedHistories[i].id);
          if (historyIndex != -1) {
            this.pendingHistories[historyIndex].result = finishedHistories[
              i
            ].result
              .replace(/[A-Z]/g, " $&")
              .trim();
            this.pendingHistories[historyIndex].duration =
              moment(finishedHistories[i].updatedAt).diff(
                moment(finishedHistories[i].createdAt),
                "seconds"
              ) + " seconds";

            this.pendingHistories.splice(historyIndex, 1);
            this.pendingIds.splice(historyIndex, 1);
            resultTaskFilter.add(finishedHistories[i].result);
          }
        }
        if (resultTaskFilter.size > 0) {
          //updates the filter of results if the result of the task changes
          this.resultTasks = Array.from(resultTaskFilter);
          this.resultTasks.sort();
          this.resultTasks = this.resultTasks.map((name) => {
            return { value: name, text: name };
          });
          let newTableFormat = this.tableFormat.slice();

          newTableFormat[1] = {
            prop: "result",
            label: "Result",
            filterOption: this.resultTasks,
            filterMethod: this.filterTaskResult,
            filterPlacement: "bottom-end",
          };
          this.tableFormat = newTableFormat;
        }
      } catch (err) {
        this.cancelAutoUpdate();
        this.handleError(err, this, this.instanceId);
      }
    },
    async makePdf(dateRanges) {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        //gets date ranges from the modals
        let date1 = new Date(dateRanges[0]);
        let date2 = new Date(dateRanges[1]).setHours(23, 59, 59);
        //gets the table data to pass into the backend
        let filterData = this.$refs.taskTable.$refs.historyTable.tableData;
        //gets all of the filter options from the headers and sees if it is filtered
        let filterOptions =
          this.$refs.taskTable.$refs.historyTable.$refs.tableHeader.columns;
        let totalFilter = { name: [], result: [], startAt: [], runBy: [] };
        for (let index = 0; index < filterOptions.length; index++) {
          //sees if there is a filter at the column then adds it based on the index
          if (filterOptions[index].filteredValue.length > 0) {
            for (let filterValue of filterOptions[index].filteredValue) {
              if (index == 0) {
                totalFilter.name.push(filterValue);
              } else if (index == 1) {
                totalFilter.result.push(filterValue);
              } else if (index == 2) {
                totalFilter.startAt.push(filterValue);
              } else if (index == 3) {
                totalFilter.runBy.push(filterValue);
              }
            }
          }
        }
        //filters the table data based on the date from the modal then passes to the backend
        filterData = filterData.filter(
          (taskFilter) =>
            date1 - this.toFloatFromDate(taskFilter.createdAt) <= 0 &&
            date2 - this.toFloatFromDate(taskFilter.createdAt) >= 0
        );
        //reduces the filterData to only have ids and passes it forward
        let filterIds = filterData.map((data) => {
          return data.id;
        });

        TaskService.getFilteredHistoryDetails(
          filterIds,
          totalFilter,
          store.state.userId,
          dateRanges
        );
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    /**
     * sorts on date as a table method
     * @param {object} a
     * @param {object} b
     */
    sortDate(a, b) {
      return (
        this.toFloatFromDate(a.createdAt) - this.toFloatFromDate(b.createdAt)
      );
    },
    toFloatFromDate(num) {
      let date = new Date(num.split(" on ").join(" "));
      return date;
    },
    /**
     * filter method for the table for run By
     * @param {string} value
     * @param {obj} row
     */
    filterRunBy(value, row) {
      return row.runBy === value;
    },
    /**
     * filter method for the table for result
     * @param {string} value
     * @param {obj} row
     */
    filterTaskResult(value, row) {
      return row.result === value;
    },
    /**
     * filter method for the table for task name
     * @param {string} value
     * @param {obj} row
     */
    filterTaskName(value, row) {
      return row.taskName === value;
    },
  },
  mounted() {
    if (!this.isUserLoggedIn) {
      this.$router.push({ name: "login" });
    } else if (!this.instanceId) {
      this.$router.push({ name: "servers" });
    } else {
      this.getHistory();
    }
  },
  created() {
    this.timer = setInterval(this.refreshTask, 10000);
  },
};
</script>

<style scoped>
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
  padding: 10px 15px;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
</style>

